import { track, logError } from '@tracking';

import getShop from '@core/reducers/shop/selectors/getShop';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopName from '@core/reducers/shop/selectors/getShopName';
import getShopLink from '@core/reducers/shop/selectors/getShopLink';
import getCart from '@core/reducers/cart/selectors/getCart';
import getCartTotal from '@core/reducers/cart/selectors/getCartTotal';
import getCartItems from '@core/reducers/cart/selectors/getCartItems';
import getFromOrderId from '@core/reducers/cart/selectors/getFromOrderId';

import getShopStatus from '@utils/tracking/getShopStatus';

import { getCartStatus, getCartOrderContent } from '../utils';

const EVENT_NAME = 'cart.started';

const trackCartStarted = () => (_, getState) => {
  try {
    const state = getState();
    const shop = getShop(state);
    const cart = getCart(state);

    const cartItems = getCartItems(state);

    const shopId = getShopId(state);
    const shopName = getShopName(state);
    const shopStatus = getShopStatus(shop);
    const cartValue = getCartTotal(state);
    const cartStatus = getCartStatus(cart);
    const orderContent = getCartOrderContent(cart);
    const shopLink = getShopLink(state);
    const repeatedOrder = Boolean(getFromOrderId(state));
    const productName = cartItems.length ? cartItems[0].name : null;

    const payload = {
      shopId,
      shopName,
      shopStatus,
      cartValue,
      cartStatus,
      orderContent,
      repeatedOrder,
      shopLink,
      productName,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackCartStarted;
